<template>
    <div>
        <div class="showBtn"
             @click="showBtn">{{showBtnCon}}<i :class="{'icon_bottom':!chooseShowBtn,'icon_top':chooseShowBtn}"></i></div>
        <ul class="choose"
            v-if="chooseShowBtn">
            <li :class="[{'active':item_sub.is_right == 1},'choose_opation','clearfix']"
                v-for="(item_sub,index_sub) in item.options">
                <div class="box">
                    <div class="left">
                        <i v-html='item_sub.option'></i>
                    </div>
                    <div class="right">
                        <span style="background: transparent;"
                              v-html='item_sub.content'></span>
                        <p class="choose_img_pic"
                           v-if="item_sub.image!=''">
                            <img :src="item_sub.image"
                                 alt="">
                        </p>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script type="text/ecmascript-6">
export default {
    data () {
        return {
            origin_options: [],
            showBtnCon: '展开选项',
            chooseShowBtn: false,
        }
    },
    computed: {
        item () { return this.list },
        question_now () { return this.now },
        index () { return this.idx },
        is_audio () {//听力默认展开选项
            if (this.isAudio != '') {
                return true;
            } else {
                return false;
            }
        }
    },
    props: ['list', 'now', 'idx', 'isAudio'],
    methods: {
        showBtn () {
            this.chooseShowBtn = !this.chooseShowBtn;
            if (this.chooseShowBtn) {
                this.showBtnCon = '收起选项';
            } else {
                this.showBtnCon = '展开选项';
            }
        },
    },
    created () {
        // //console.log(this.is_audio)
        if (this.is_audio) {
            this.chooseShowBtn = true;
            this.showBtnCon = '收起选项';
        }
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";
.choose {
    // padding:25px/$ppr;
    background: #fff;
    font-size: 30px / $ppr;
    .active {
        color: #66cc22;
        .left {
            i {
                border-color: #66cc22 !important;
                // border:none;
                background: #66cc22;
                color: #fff;
            }
        }
    }
    .choose_opation {
        padding: 25px / $ppr;
        line-height: 46px / $ppr;
        border-bottom: 1px / $ppr solid #dcdcdc;
        position: relative;
        min-height: 46px / $ppr;
        // align-items:center;
        .left {
            position: absolute;
            top: 50%;
            left: 25px / $ppr;
            margin-top: -51px / $ppr;
            line-height: 46px / $ppr;
            padding: 25px / $ppr 0;
            i {
                display: block;
                width: 48px / $ppr;
                line-height: 52px / $ppr;
                height: 48px / $ppr;
                text-align: center;
                border-radius: 50%;
                border: 2px / $ppr solid #dcdcdc;
                margin-right: 25px / $ppr;
            }
        }
        .right {
            margin-left: 75px / $ppr;
            line-height: 46px / $ppr;
        }
    }
}
.showBtn {
    border-bottom: $line 1px / $ppr solid;
    line-height: 96px / $ppr;
    height: 96px / $ppr;
    color: #5e89ef;
    font-size: 30px / $ppr;
    padding-left: 40px / $ppr;
    position: relative;
    background: #fff;
    i {
        display: block;
        width: 25px / $ppr;
        height: 13px / $ppr;
        position: absolute;
        top: 42px / $ppr;
        left: 170px / $ppr;
    }
    .icon_bottom {
        background: url("./img/icon_open.png") 0 0 no-repeat;
        background-size: 100% 100%;
    }
    .icon_top {
        background: url("./img/icon_close.png") 0 0 no-repeat;
        background-size: 100% 100%;
    }
}
</style>

